import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddressItem from '../../../../components/AddressItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import PageHeader from '../../../../components/PageHeader';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import StorageService from '../../../../services/StorageService';
import TypesService from '../../../../services/TypesService';
import { cardSlice } from '../../../../store/slices';

import { usePageContext } from '../../../../hooks/usePageContext';
import './CloseCardWithdrawalAccount.scss';

const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const CloseCardWithdrawalAccount = () => {
	const { useSearchParams, useSelector } = usePageContext();

	const [addressesLoading, setAddressesLoading] = useState(false);
	const [baseCurrencyAddress, setBaseCurrencyAddress] = useState();
	const [walletAddresses, setWalletAddresses] = useState([]);

	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const cardsList = useSelector(state => state.card.cardsList);

	const searchParams = useSearchParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const cardId = Number(searchParams.get('cardId'));
	const assetId = Number(searchParams.get('assetId'));
	const card = cardsList.find(card => card.Id === cardId);
	const asset = availableCurrencies.find(currency => currency.Id === assetId);
	const cardAddress = card.Addresses.find(address => address.CurrencyId === assetId);

	const anotherCardsAddresses = cardsList
		.map(cardItem => {
			const address = cardItem.Addresses?.find(address => address.CurrencyId === assetId);
			if (cardItem.Id !== cardId && address) return address;
		})
		.filter(Boolean);
	const allSourceAddresses = [...walletAddresses, ...anotherCardsAddresses].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const currencyData = CurrenciesById[assetId];
	const blockchainData = BlockchainsById[currencyData.BlockchainId];

	const getAddresses = async assetId => {
		try {
			setAddressesLoading(true);
			const response = await RequestService.GetAddressesByCurrency(assetId);
			setAddressesLoading(false);
			if (response?.Status === 'Success') {
				setWalletAddresses(response.Addresses);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchBaseCurrencyAddress = async () => {
		try {
			const feeCurrencyId = Object.keys(TypesService.CurrenciesById).find(currencyId => {
				const currency = TypesService.CurrenciesById[currencyId];
				return currency.BlockchainId === currencyData.BlockchainId && !currency.Standart;
			});
			const numericFeeCurrencyId = Number(feeCurrencyId) || 0;

			const response = await RequestService.GetAddressesByCurrency(numericFeeCurrencyId);
			if (response.Status === 'Success') {
				const address = response.Addresses.find(address => address.Address === cardAddress.Address);
				setBaseCurrencyAddress(address);
			}
		} catch (error) {
			setBaseCurrencyAddress();
		}
	};

	useEffect(() => {
		StorageService.UpdateQuotes();
		getAddresses(assetId);
	}, [assetId]);

	useEffect(() => {
		if (currencyData.FeeType === 'back_calculating' && !baseCurrencyAddress) {
			fetchBaseCurrencyAddress();
		}
	}, [asset]);

	const selectAddress = recipientAddress => {
		dispatch(
			cardSlice.actions.closeCardSetWithdrawAddress({
				assetId,
				cardAddress,
				recipientAddress,
				cardId,
			})
		);
		navigate(-1);
	};

	return (
		<div className='CloseCardWithdrawalAccount SubPageWrapper'>
			<PageHeader
				header={'Select address'}
				subheader={<>{currencyData.Name + ' ' + blockchainData.Name + ' ' + currencyData.Standart}</>}
				icon={currencyData.CompanyIcon}
				iconLabel={currencyData.CompanyIcon !== blockchainData.Icon ? blockchainData.Icon : null}
			/>
			<div className='SubPageBody'>
				{allSourceAddresses.length || addressesLoading ? (
					<div className='FormBlock'>
						{allSourceAddresses.map((address, index) => (
							<AddressItem
								key={index}
								address={address}
								lastItem={index === allSourceAddresses.length - 1}
								onClick={selectAddress}
							/>
						))}
					</div>
				) : (
					<div className='CloseCardWithdrawalAccount__empty-state'>
						<Icon type={Icons.EMPTY_ACCOUNT_LIST_ICON} width={240} height={124} />
						<div className='CloseCardWithdrawalAccount__empty-header'>{t('No addresses yet')}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default CloseCardWithdrawalAccount;
